/**
 * @module FE-CU42_緊急連絡先設定_追加モーダル画面
 */
export default {
  name: 'AddContactModal',
  props: ['valid', 'dialog', 'error', 'rules', 'appendAlertClass', 'sortFlag', 'isDisabled'],
  data() {
    return {
      childDialog: this.dialog,
      displayDialog: false,
      childValid: this.valid,
      contact: {
        id: 0,
        name: '',
        nameKana: '',
        relationship: '',
        phoneNumber: '',
      },
    };
  },
  computed: {
    disabled() {
      return (
        !this.childValid ||
        !this.contact.name ||
        !this.contact.nameKana ||
        !this.contact.relationship ||
        !this.contact.phoneNumber
      );
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * キャンセルボタン押下時処理
     */
    closeDialog() {
      this.childDialog = false;
      setTimeout(() => {
        this.displayDialog = false;
      }, 200);
    },
    /**
     * 追加ボタン押下時処理
     */
    openModal() {
      this.contactClear();
      this.displayDialog = true;
    },
    /**
     * 登録ボタン押下時処理
     */
    addContact() {
      if (this.$refs.form.validate()) {
        let chidlContact = {
          id: 0,
          name: '',
          nameKana: '',
          relationship: '',
          phoneNumber: '',
        };
        chidlContact.id = this.contact.id;
        chidlContact.name = this.contact.name;
        chidlContact.nameKana = this.contact.nameKana;
        chidlContact.relationship = this.contact.relationship;
        chidlContact.phoneNumber = this.contact.phoneNumber;
        this.childValid = true;
        this.$emit('add-contact', chidlContact);
        this.closeDialog();
      }
    },
    /**
     * 入力項目の初期化
     */
    contactClear() {
      this.contact.id = 0;
      this.contact.name = '';
      this.contact.nameKana = '';
      this.contact.relationship = '';
      this.contact.phoneNumber = '';
    },
  },
};
